import { FC, useEffect, memo, useCallback, useRef, MutableRefObject, useState } from "react";
import { useNavigate} from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { AppState, AppThunk } from "../../store";
import { fetchAllJobs } from "../../store/jobsData";
import AdminPage from "../AdminPage";
import { apiClient } from "../../utils/apiClient";

export type Props = any;
const DocsTable = ({ docs }: { docs: any[] }) => {
  const navigate = useNavigate();

  const handleRowClick = (id: string) => {
    navigate(`/doc/${id}`);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Source</TableCell>
            <TableCell>Tags</TableCell>
            <TableCell>Content</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {docs.map((doc) => (
            <TableRow
              key={doc._id}
              hover
              onClick={() => handleRowClick(doc._id)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell>{doc.title}</TableCell>
              <TableCell>{doc.source}</TableCell>
              <TableCell>{doc.tags.join(', ')}</TableCell>
              <TableCell>{`${(doc.content as string).slice(0, 100)}...`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const DocsList: FC<Props> = (): JSX.Element => {
  const [docs, setDocs] = useState<any[]>([]);
  const textFieldRef = useRef<HTMLInputElement>();
  const docTagRef = useRef<HTMLInputElement>();
  useEffect(() => {
    const fetchData = async () => {
      try {
      const data = await apiClient.post<any[]>(`/document/`);
        setDocs(data);
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <AdminPage>
      <div>
        <TextField
          label="gdrive folder Id"
          variant="outlined"
          // value='0B3rC_iWT1v9dZTE1NHotN2RtcE0'
          inputRef={textFieldRef}
        />
        <TextField
          label="Doc Tag"
          variant="outlined"
          inputRef={docTagRef}
        />
        <Button onClick={async () => {
          const folderId = textFieldRef.current?.value;
          const docTag = docTagRef.current?.value;
          const data = await apiClient.post<any>(`/jobs/enqueue/test_download_doc?folder_id=${folderId}&tag=${docTag}`);
          console.log(data);
        }}>download folder</Button>
      </div>
      <div>
        <Button onClick={async () => {
          const data = await apiClient.post<any>('/document/delete_all');
          console.log(data);
        }}>delete all</Button>
      </div>
      <DocsTable docs={docs} ></DocsTable>
    </AdminPage>
  );
};

// server-side data here
// export const loadData = (): AppThunk[] => [fetchAllJobs()];
export const loadData = (): AppThunk[] => [];

export default memo(DocsList);
